import MinusBtn from "@/assets/MinusBtn.png";
import PlusBtn from "@/assets/PlusBtn.png";

const ButtonSlider: React.FC<{
  label: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  suffix?: string;
}> = ({ label, value, onChange, min, max, suffix = "%" }) => {
  const handleIncrease = () => {
    const currentValue = Number(value);
    const newValue = Math.min(max, currentValue + 1);
    onChange(newValue);
  };

  const handleDecrease = () => {
    const currentValue = Number(value);
    const newValue = Math.max(min, currentValue - 1);
    onChange(newValue);
  };

  return (
    <div className="flex justify-between items-center mb-4">
      <span className="w-[30%] text-[16px] font-normal">{label}</span>
      <div className="w-[65%]">
        <div
          style={{ boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.07) inset" }}
          className="h-[56px] flex items-center gap-[8px] p-[8px] rounded-[100px] bg-[#F8F8F8] border-[1px] border-[#E2E2E2]"
        >
          <div
            onClick={handleDecrease}
            className="cursor-pointer w-[40px] h-[40px]"
          >
            <img src={MinusBtn} alt="Decrease" />
          </div>

          <div className="flex-1 flex items-center justify-center leading-[127%]">
            {value > min && (
              <span className="text-[18px] font-semibold text-gray-200 mr-4">
                {value - 1}
                {suffix}
              </span>
            )}
            <span className="text-[24px] font-bold text-gray-800">
              {value}
              {suffix}
            </span>
            {value < max && (
              <span className="text-[18px] font-semibold text-gray-200 ml-4">
                {value + 1}
                {suffix}
              </span>
            )}
          </div>

          <div
            onClick={handleIncrease}
            className="cursor-pointer w-[40px] h-[40px]"
          >
            <img src={PlusBtn} alt="Increase" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonSlider;
